import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { CashReconciliationDetail } from '../../../../../Model/cashReconciliationXModel'

interface RejectReconciliationModalProps {
  show: boolean
  onHide: () => void
  onConfirm: (payload: { notes: string }) => void
  submission: CashReconciliationDetail | null
  submitting: boolean
}

const RejectReconciliationModal: React.FC<RejectReconciliationModalProps> = ({
  show,
  onHide,
  onConfirm,
  submission,
  submitting,
}) => {
  const [notes, setNotes] = useState('')

  // Reset form when modal opens/closes
  React.useEffect(() => {
    if (show) {
      setNotes('')
    }
  }, [show])

  if (!submission) return null

  const handleSubmit = () => {
    if (notes.trim()) {
      onConfirm({ notes })
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered className='bx-reject-reconciliation-modal'>
      <div className='bx-modal__content p-4'>
        <div className='d-flex justify-content-between align-items-start mb-4'>
          <h4 className='bx-modal__title m-0'>Reject for correction</h4>
          <button type='button' className='btn-close' onClick={onHide} disabled={submitting} />
        </div>

        <div className='bx-modal__body'>
          <div className='bx-modal__report-summary mb-4'>
            <h5 className='m-0 mb-1'>{submission.stationName || submission.stationId}</h5>
            <p className='m-0 text-muted'>Date: {submission.reportDate}</p>
          </div>

          <div className='form-group mb-4'>
            <label className='form-label'>Add notes</label>
            <textarea
              className='form-control'
              rows={4}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder='Explain the shortage or overage and what the manager should correct.'
              disabled={submitting}
              maxLength={2000}
            />
          </div>

          <button
            type='button'
            className='btn bx-modal__submit w-100 py-2'
            onClick={handleSubmit}
            disabled={!notes.trim() || submitting}
          >
            {submitting ? 'Sending...' : 'Send back to manager'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default RejectReconciliationModal
